import React from 'react';
import { useNavigate } from 'react-router-dom';

interface OnboardingWelcomeProps {
  onNext: () => void;
}

const OnboardingWelcome: React.FC<OnboardingWelcomeProps> = ({ onNext }) => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <div style={styles.hero}>
        <h2 style={styles.heading}>Welcome to Store Club</h2>
        <p style={styles.subheading}>
          Your members-only feed experience at Red Bridge Farm
        </p>
      </div>

      <div style={styles.features}>
        <div style={styles.feature}>
          <div style={styles.featureIcon}>24/7</div>
          <div style={styles.featureContent}>
            <h3 style={styles.featureTitle}>Locker Pickup</h3>
            <p style={styles.featureText}>Pick up your orders anytime with secure locker access</p>
          </div>
        </div>

        <div style={styles.feature}>
          <div style={styles.featureIcon}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 20V10M18 20V4M6 20v-4" />
            </svg>
          </div>
          <div style={styles.featureContent}>
            <h3 style={styles.featureTitle}>Smart Reminders</h3>
            <p style={styles.featureText}>We'll track when you're running low and remind you</p>
          </div>
        </div>

        <div style={styles.feature}>
          <div style={styles.featureIcon}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
            </svg>
          </div>
          <div style={styles.featureContent}>
            <h3 style={styles.featureTitle}>BYOC Savings</h3>
            <p style={styles.featureText}>Bring Your Own Container for bulk feed discounts</p>
          </div>
        </div>

        <div style={styles.feature}>
          <div style={styles.featureIcon}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
            </svg>
          </div>
          <div style={styles.featureContent}>
            <h3 style={styles.featureTitle}>Weather Alerts</h3>
            <p style={styles.featureText}>Get notified about dangerous conditions for your animals</p>
          </div>
        </div>
      </div>

      <div style={styles.actions}>
        <button style={styles.primaryButton} onClick={onNext}>
          Join Store Club - Free!
        </button>
        <button
          style={styles.secondaryButton}
          onClick={() => navigate('/club/login')}
        >
          Already a member? Sign In
        </button>
      </div>

      <p style={styles.disclaimer}>
        Store Club membership is free. You'll create a password during registration.
      </p>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
  },
  hero: {
    textAlign: 'center',
  },
  heading: {
    fontSize: '1.75rem',
    fontWeight: 'bold',
    color: '#E73C3E',
    margin: '0 0 0.5rem 0',
    fontFamily: "'Open Sans', sans-serif",
  },
  subheading: {
    fontSize: '1rem',
    color: '#666',
    margin: 0,
  },
  features: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  feature: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    backgroundColor: '#fff',
    padding: '1rem',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },
  featureIcon: {
    width: '48px',
    height: '48px',
    borderRadius: '12px',
    backgroundColor: '#508590',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1rem',
    fontWeight: 'bold',
    flexShrink: 0,
  },
  featureContent: {
    flex: 1,
  },
  featureTitle: {
    fontSize: '1rem',
    fontWeight: 600,
    color: '#333',
    margin: '0 0 0.25rem 0',
  },
  featureText: {
    fontSize: '0.875rem',
    color: '#666',
    margin: 0,
    lineHeight: '1.4',
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    marginTop: '1rem',
  },
  primaryButton: {
    backgroundColor: '#E73C3E',
    color: '#fff',
    border: 'none',
    padding: '1rem 1.5rem',
    borderRadius: '8px',
    fontSize: '1.125rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    fontFamily: "'Open Sans', sans-serif",
  },
  secondaryButton: {
    backgroundColor: 'transparent',
    color: '#508590',
    border: '2px solid #508590',
    padding: '0.875rem 1.5rem',
    borderRadius: '8px',
    fontSize: '1rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s',
    fontFamily: "'Open Sans', sans-serif",
  },
  disclaimer: {
    textAlign: 'center',
    fontSize: '0.75rem',
    color: '#999',
    margin: 0,
  },
};

export default OnboardingWelcome;
